import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button, FormControl, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { decryptId } from "../../utils/helpers";

const API_URL = process.env.REACT_APP_API_URL;

function PIWILProteinExpression() {

  const { sample_id } = useParams();


  const decodedId = decodeURIComponent(sample_id);
  const id_sample = decryptId(decodedId);
  const alertShown = useRef(false);

  const [formData, setFormData] = useState({
    sample_id: "",
    mena_id: "",
    piwil1_avg: "",
    piwil2_avg: "",
    piwil3_avg: "",
    piwil4_avg: "",

    piwil1_copies: "",
    piwil2_copies: "",
    piwil3_copies: "",
    piwil4_copies: "",

    piwil1_slope: "",
    piwil2_slope: "",
    piwil3_slope: "",
    piwil4_slope: "",

    piwil1_intercempt: "",
    piwil2_intercempt: "",
    piwil3_intercempt: "",
    piwil4_intercempt: "",

    remark: "",
  });


  const calculateCopies = (avg, slope, intercept) => {
    const a = parseFloat(avg);
    const m = parseFloat(slope);
    const b = parseFloat(intercept);

    if (isNaN(a) || isNaN(m) || isNaN(b) || m === 0) return "";
    return ((a - b) / m).toFixed(4);
  };

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");




  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      piwil1_copies: calculateCopies(
        prev.piwil1_avg,
        prev.piwil1_slope,
        prev.piwil1_intercempt
      ),
      piwil2_copies: calculateCopies(
        prev.piwil2_avg,
        prev.piwil2_slope,
        prev.piwil2_intercempt
      ),
      piwil3_copies: calculateCopies(
        prev.piwil3_avg,
        prev.piwil3_slope,
        prev.piwil3_intercempt
      ),
      piwil4_copies: calculateCopies(
        prev.piwil4_avg,
        prev.piwil4_slope,
        prev.piwil4_intercempt
      ),
    }));
  }, [
    formData.piwil1_avg,
    formData.piwil1_slope,
    formData.piwil1_intercempt,
    formData.piwil2_avg,
    formData.piwil2_slope,
    formData.piwil2_intercempt,
    formData.piwil3_avg,
    formData.piwil3_slope,
    formData.piwil3_intercempt,
    formData.piwil4_avg,
    formData.piwil4_slope,
    formData.piwil4_intercempt,
  ]);
  /////////////////////////////////start new logic for the new recomended changes /////////////////

  const [manualCopies, setManualCopies] = useState({
    piwil1: false,
    piwil2: false,
    piwil3: false,
    piwil4: false,
  });
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,

      piwil1_copies: manualCopies.piwil1
        ? prev.piwil1_copies
        : calculateCopies(
          prev.piwil1_avg,
          prev.piwil1_slope,
          prev.piwil1_intercempt
        ),

      piwil2_copies: manualCopies.piwil2
        ? prev.piwil2_copies
        : calculateCopies(
          prev.piwil2_avg,
          prev.piwil2_slope,
          prev.piwil2_intercempt
        ),

      piwil3_copies: manualCopies.piwil3
        ? prev.piwil3_copies
        : calculateCopies(
          prev.piwil3_avg,
          prev.piwil3_slope,
          prev.piwil3_intercempt
        ),

      piwil4_copies: manualCopies.piwil4
        ? prev.piwil4_copies
        : calculateCopies(
          prev.piwil4_avg,
          prev.piwil4_slope,
          prev.piwil4_intercempt
        ),
    }));
  }, [
    formData.piwil1_avg,
    formData.piwil1_slope,
    formData.piwil1_intercempt,

    formData.piwil2_avg,
    formData.piwil2_slope,
    formData.piwil2_intercempt,

    formData.piwil3_avg,
    formData.piwil3_slope,
    formData.piwil3_intercempt,

    formData.piwil4_avg,
    formData.piwil4_slope,
    formData.piwil4_intercempt,

    manualCopies,
  ]);

  /////////////////////////////////////end new change/////////////////////////////////////////////////////////////////
  // const [manualCopies, setManualCopies] = useState({
  //   piwil1: false,
  //   piwil2: false,
  //   piwil3: false,
  //   piwil4: false,
  // });
  useEffect(() => {
    if (!id_sample) return;

    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_URL}/piwil-protein/${id_sample}`);

        if (res.data?.status && res.data?.PiwilMrnaModel) {
          setFormData(prev => ({
            ...prev,
            ...res.data.PiwilMrnaModel
          }));
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchData();
  }, [id_sample]);




  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.mena_id) {
      alert("Data not loaded yet");
      return;
    }

    const token = localStorage.getItem("token");



    try {
      const res = await axios.put(
        `${API_URL}/piwil-protein-update/${formData.mena_id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // alert(res.data.message || "Saved successfully");
      setSuccessMsg(
        res.data.message || `PIWIL Protein Expression data saved successfully`
      ); setErrorMsg("");

      setTimeout(() => setSuccessMsg(""), 1000);
    } catch (err) {
      console.error(err);
      setErrorMsg("Save failed");
    }
  };



  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


  // const handleSave = async () => {
  //   try {
  //     const res = await axios.post(
  //       `${API_URL}/piwil-protein-update/${formData.sample_id}`,
  //       formData
  //     );

  //     setSuccessMsg(res.data.message || "Updated successfully");
  //     setErrorMsg("");
  //     setTimeout(() => setSuccessMsg(""), 2000);
  //   } catch (error) {
  //     console.error(error);
  //     setErrorMsg("Update failed");
  //     setTimeout(() => setErrorMsg(""), 2000);
  //   }
  // };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const res = await axios.get(`${API_URL}/piwil-protein/${formData.sample_id}`);
  //       if (res.data.status && res.data.data.length > 0) {
  //         setFormData((prev) => ({ ...prev, ...res.data.data[0] }));
  //       }
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     }
  //   };
  //   fetchData();
  // }, [formData.sample_id]);

  const inputStyle = {
    width: "100%",
    maxWidth: "120px",
    height: "35px",
    border: "2px solid #001A43",
    borderRadius: "4px",
    margin: "5px 0",
    textAlign: "center",
  };

  const labelStyle = {
    backgroundColor: "#DFF5F1",
    padding: "6px 12px",
    borderRadius: "6px",
    border: "1px solid #4DB6AC",
    textAlign: "center",
    whiteSpace: "nowrap",
  };

  const copiesInputStyle = {
    ...inputStyle,
    backgroundColor: "#E8F0FF",
  };

  return (
    <div>
      <h6 style={{ textAlign: "left" }}>PIWIL Protein Expression</h6>

      {successMsg && (
        <div className="alert alert-success mt-2">
          {successMsg}
        </div>
      )}

      {errorMsg && (
        <div className="alert alert-danger mt-2">
          {errorMsg}
        </div>
      )}

      <Form onSubmit={handleSubmit}>
        <div className="grid-container">
          {/* Header row */}
          <div></div>
          <div style={labelStyle}>OD (Avg)</div>
          <div style={labelStyle}>Conc (pg/mL)</div>
          <div></div>
          <div style={labelStyle}>Slope (m)</div>
          <div style={labelStyle}>Y intercept (b)</div>

          {/* PIWIL 1 */}
          <div style={labelStyle}>PIWIL 1 protein</div>
          <FormControl type="number"
            name="piwil1_avg"
            style={inputStyle}
            value={formData.piwil1_avg ?? ""}
            onChange={handleChange}
          />
          <FormControl type="number"
            name="piwil1_copies"
            style={inputStyle}
            value={formData.piwil1_copies ?? ""} onChange={(e) => {
              setManualCopies((prev) => ({
                ...prev,
                piwil1: true,
              })); setFormData((prev) => ({
                ...prev,
                piwil1_copies: e.target.value,
              }));
            }}

          />
          <div style={labelStyle}>PIWIL 1 Std</div>
          <FormControl type="number"
            name="piwil1_slope"
            style={inputStyle}
            value={formData.piwil1_slope ?? ""}
            onChange={handleChange}
          />
          <FormControl
            name="piwil1_intercempt" type="number"
            style={inputStyle}
            value={formData.piwil1_intercempt ?? ""}
            onChange={handleChange}
          />

          {/* PIWIL 2 */}
          <div style={labelStyle}>PIWIL 2 protein</div>
          <FormControl
            name="piwil2_avg" type="number"
            style={inputStyle}
            value={formData.piwil2_avg ?? ""}
            onChange={handleChange}
          />
          <FormControl
            name="piwil2_copies" type="number"
            style={inputStyle}
            value={formData.piwil2_copies ?? ""} onChange={(e) => {
              setManualCopies((prev) => ({
                ...prev,
                piwil2: true,
              }));

              setFormData((prev) => ({
                ...prev,
                piwil2_copies: e.target.value,
              }));
            }}

          />
          <div style={labelStyle}>PIWIL 2 Std</div>
          <FormControl
            name="piwil2_slope" type="number"
            style={inputStyle}
            value={formData.piwil2_slope ?? ""}
            onChange={handleChange}
          />
          <FormControl
            name="piwil2_intercempt" type="number"
            style={inputStyle}
            value={formData.piwil2_intercempt ?? ""}
            onChange={handleChange}
          />

          {/* PIWIL 3 */}
          <div style={labelStyle}>PIWIL 3 protein</div>
          <FormControl
            name="piwil3_avg" type="number"
            style={inputStyle}
            value={formData.piwil3_avg ?? ""}
            onChange={handleChange}
          />
          <FormControl
            name="piwil3_copies" type="number"
            style={inputStyle}
            value={formData.piwil3_copies ?? ""} onChange={(e) => {
              setManualCopies((prev) => ({
                ...prev,
                piwil3: true,
              }));

              setFormData((prev) => ({
                ...prev,
                piwil3_copies: e.target.value,
              }));
            }}

          />
          <div style={labelStyle}>PIWIL 3 Std</div>
          <FormControl
            name="piwil3_slope" type="number"
            style={inputStyle}
            value={formData.piwil3_slope ?? ""}
            onChange={handleChange}
          />
          <FormControl
            name="piwil3_intercempt" type="number"
            style={inputStyle}
            value={formData.piwil3_intercempt ?? ""}
            onChange={handleChange}
          />

          {/* PIWIL 4 */}
          <div style={labelStyle}>PIWIL 4 protein</div>
          <FormControl
            name="piwil4_avg" type="number"
            style={inputStyle}
            value={formData.piwil4_avg ?? ""}
            onChange={handleChange}
          />
          <FormControl
            name="piwil4_copies" type="number"
            style={inputStyle}
            value={formData.piwil4_copies ?? ""}

            onChange={(e) => {
              setManualCopies((prev) => ({
                ...prev,
                piwil4: true,
              }));

              setFormData((prev) => ({
                ...prev,
                piwil4_copies: e.target.value,
              }));
            }}

          />
          <div style={labelStyle}>PIWIL 4 Std</div>
          <FormControl
            name="piwil4_slope" type="number"
            style={inputStyle}
            value={formData.piwil4_slope ?? ""}
            onChange={handleChange}
          />
          <FormControl
            name="piwil4_intercempt" type="number"
            style={inputStyle}
            value={formData.piwil4_intercempt ?? ""}
            onChange={handleChange}
          />
        </div>

        <div style={{ marginTop: "20px" }}>
          <FormControl
            as="textarea"
            name="remark"
            rows={2}
            value={formData.remark ?? ""}
            onChange={handleChange}
            placeholder="Enter remarks here"
            style={{ width: "100%", maxWidth: "1000px" }}
          />
        </div>

        <div className="d-flex justify-content-center mt-4">
          <Button
            type="submit"
            className="px-4 mb-4"
            variant="primary"


          >
            Save
          </Button>
        </div>
      </Form>

      <style>
        {`
          .grid-container {
            display: grid;
            grid-template-columns: repeat(6, auto);
            gap: 12px 20px;
            align-items: center;
            margin-top: 15px;
          }

          @media (max-width: 992px) {
            .grid-container {
              grid-template-columns: repeat(3, auto);
            }
          }

          @media (max-width: 600px) {
            .grid-container {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
    </div>
  );
}

export default PIWILProteinExpression;
